module.exports = __webpack_public_path__ + "static/sydework-3391d04608c0ad6d4031c7885ab48a72.png";